import type { RequiredGeneric } from '@pba/react-utils';
import cn from 'classnames';
import { Col, Divider, Form, FormSection, Icon, Radio, Row } from 'ui';
import { InvitationsDuplicateFormContentOption } from './invitations-duplicate-form-content-option';

export type ExtendedInvitationsDuplicateFormValues = {
  duplicateInviteesFromEvent: boolean;
};

type P = {
  label: string;
  noDescription: string;
  title: string;
  yesDescription: string;
};

const InvitationsDuplicateFormContent = <T extends ExtendedInvitationsDuplicateFormValues = never>({
  label,
  noDescription,
  title,
  yesDescription,
}: RequiredGeneric<T, P>) => {
  const shouldDuplicateInvitees =
    Form.useWatch<ExtendedInvitationsDuplicateFormValues['duplicateInviteesFromEvent']>('duplicateInviteesFromEvent');

  return (
    <FormSection title={{ children: title, icon: <Icon icon="group-line" /> }}>
      <Form.Item<ExtendedInvitationsDuplicateFormValues>
        label={label}
        name="duplicateInviteesFromEvent"
        rules={[{ required: true }]}
      >
        <Radio.Group>
          <Row className="invitations-duplicate-form-content">
            <Col className={cn({ 'invitations-duplicate-form-content__active': shouldDuplicateInvitees })} span={24}>
              <InvitationsDuplicateFormContentOption
                active={shouldDuplicateInvitees}
                description={yesDescription}
                icon={<Icon icon="group-line" />}
                title="Yes"
                value
              />
            </Col>
            <Col span={24}>
              <Divider marginNone />
            </Col>
            <Col className={cn({ 'invitations-duplicate-form-content__active': !shouldDuplicateInvitees })} span={24}>
              <InvitationsDuplicateFormContentOption
                active={!shouldDuplicateInvitees}
                description={noDescription}
                icon={<Icon icon="forbid-circle-line" />}
                title="No"
                value={false}
              />
            </Col>
          </Row>
        </Radio.Group>
      </Form.Item>
    </FormSection>
  );
};

export default InvitationsDuplicateFormContent;
